export function clientProxyBaseUrl(): string {
  const baseUrl = import.meta.env.VITE_CLIENT_PROXY_API;
  if (typeof baseUrl === 'string' && baseUrl.length > 0) {
    return baseUrl.replace(/\/$/, '');
  }
  return '';
}

export function punterPreferencesPath(tenantUuid: string, punterId: string): string {
  return `/tenants/${tenantUuid}/punters/${punterId}/punter-preferences`;
}
